import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/model/pendingModel.ts";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.define-property.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createStore } from 'effector';
import * as api from '@gmini/sm-api-sdk';

var updatePending = function updatePending(map, key) {
  var newMap = _objectSpread({}, map);

  delete newMap[key];
  return newMap;
};

export var pendingMapClassifier$ = createStore({}, {
  ɔ: {
    name: 'pendingMapClassifier'
  },
  name: "pendingMapClassifier$",
  sid: "-sgpr3c"
}).on(api.UserClassifierGroup.fetch.defaultContext.submit.map(function (_ref) {
  var id = _ref.id;
  return "UserClassifierGroup".concat(id);
}), function (map, key) {
  return _objectSpread(_objectSpread({}, map), {}, _defineProperty({}, key, true));
}).on(api.UserClassifierGroup.fetch.defaultContext["finally"].map(function (_ref2) {
  var id = _ref2.params.id;
  return "UserClassifierGroup".concat(id);
}), function (map, key) {
  return updatePending(map, key);
}).on(api.DynamicGroup.fetch.defaultContext.submit.map(function (_ref3) {
  var dynamicGroupId = _ref3.dynamicGroupId;
  return "DynamicBaseGroup".concat(dynamicGroupId);
}), function (map, key) {
  return _objectSpread(_objectSpread({}, map), {}, _defineProperty({}, key, true));
}).on(api.DynamicGroup.fetch.defaultContext["finally"].map(function (_ref4) {
  var dynamicGroupId = _ref4.params.dynamicGroupId;
  return "DynamicBaseGroup".concat(dynamicGroupId);
}), function (map, key) {
  return updatePending(map, key);
}).on(api.BimModel.Populated.fetch.defaultContext.submit.map(function (_ref5) {
  var key = _ref5.key;
  return key;
}), function (map, key) {
  return _objectSpread(_objectSpread({}, map), {}, _defineProperty({}, key, true));
}).on(api.BimModel.Populated.fetch.defaultContext["finally"].map(function (_ref6) {
  var key = _ref6.params.key;
  return key;
}), function (map, key) {
  return updatePending(map, key);
}).on(api.BimCategory.Populated.fetch.defaultContext.submit.map(function (_ref7) {
  var key = _ref7.key;
  return key;
}), function (map, key) {
  return _objectSpread(_objectSpread({}, map), {}, _defineProperty({}, key, true));
}).on(api.BimCategory.Populated.fetch.defaultContext["finally"].map(function (_ref8) {
  var key = _ref8.params.key;
  return key;
}), function (map, key) {
  return updatePending(map, key);
}).on(api.BimFamily.Populated.fetch.defaultContext.submit.map(function (_ref9) {
  var key = _ref9.key;
  return key;
}), function (map, key) {
  return _objectSpread(_objectSpread({}, map), {}, _defineProperty({}, key, true));
}).on(api.BimFamily.Populated.fetch.defaultContext["finally"].map(function (_ref10) {
  var key = _ref10.params.key;
  return key;
}), function (map, key) {
  return updatePending(map, key);
}).on(api.BimStandardSize.Populated.fetch.defaultContext.submit.map(function (_ref11) {
  var key = _ref11.key;
  return key;
}), function (map, key) {
  return _objectSpread(_objectSpread({}, map), {}, _defineProperty({}, key, true));
}).on(api.BimStandardSize.Populated.fetch.defaultContext["finally"].map(function (_ref12) {
  var key = _ref12.params.key;
  return key;
}), function (map, key) {
  return updatePending(map, key);
}).on(api.BimElement.fetchByIds.defaultContext.submit.map(function (_ref13) {
  var key = _ref13.key;
  return key;
}), function (map, key) {
  return _objectSpread(_objectSpread({}, map), {}, _defineProperty({}, key, true));
}).on(api.BimElement.fetchByIds.defaultContext["finally"].map(function (_ref14) {
  var key = _ref14.params.key;
  return key;
}), function (map, key) {
  return updatePending(map, key);
});
export function buildNodeVariantsPendingKey(_ref15) {
  var id = _ref15.id,
      type = _ref15.type;
  return "".concat(type, ":").concat(id);
}
export function getGroupPendingKey(node, dynamicGroupMode) {
  if (node.type === 'DynamicBaseGroupNode' || node.type === 'DynamicGeneratedGroupNode') {
    return "DynamicBaseGroup".concat(node.id);
  }

  if (dynamicGroupMode && node.dynamicGroup) {
    var _node$dynamicGroup;

    return ((_node$dynamicGroup = node.dynamicGroup) === null || _node$dynamicGroup === void 0 ? void 0 : _node$dynamicGroup.type) === 'DynamicBaseGroupNode' ? "DynamicBaseGroup".concat(node.dynamicGroup.id) : "DynamicGeneratedGroup".concat(node.dynamicGroup.id);
  }

  return "UserClassifierGroup".concat(node.id);
}